

































import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action, namespace } from 'vuex-class';
import { CurrentUser } from "@/pitprojekt/models/CurrentUser";
import { EventBus } from "@/pitprojekt/event-bus";
const SettingsModule = namespace('SettingsModule')
const AuthModule = namespace('AuthModule')

@Component({})
export default class UserProfile extends Vue {
  @SettingsModule.Getter('currentUser') currentUser!: CurrentUser;
  @AuthModule.Action('logout') logout: any;

  getAvatarUrl(): string {
    return this.currentUser.avatar;
  }

  showChangePasswordDialog() {
    EventBus.$emit('showChangePasswordDialogEvent');
  }



}
